import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { CdnImg } from '@webplatform/cdn-image';

type Colors = 'gray' | 'red' | 'yellow' | 'blue';
interface Props {
  title?: string;
  description?: string;
  color: Colors;
  img?: string;
  link?: {
    text?: string;
    url?: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutCard',
  props: {
    title: { default: '' },
    description: { default: '' },
    color: { default: 'gray' },
    img: { default: '/' },
    link: { default: () => ({
    text: 'Link',
    url: '#',
  }) }
  },
  setup(__props: any) {

const props = __props as { title: string, description: string, color: Colors, img: string, link: {
    text?: string;
    url?: string;
  } };

const figuresColors: Record<Colors, string> = {
  gray: 'yellow',
  red: 'white',
  yellow: 'white',
  blue: 'aqua',
};



const figuresColor = computed(() => figuresColors[props.color]);

return { __sfc: true,figuresColors, props, figuresColor, CdnImg }
}

})